import styled from 'styled-components'

export const QuestionsContainerWrapper = styled.div`
  padding: ${({ theme }) => theme.spaces.min5};
`
